import { render, staticRenderFns } from "./StatisticsCardMultiple.vue?vue&type=template&id=4f128cd7&"
import script from "./StatisticsCardMultiple.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports